import { Box, BoxProps, Stack, Typography, useTheme } from "@mui/material";
import React from "react";

export interface EmptyStateProps extends Omit<BoxProps, "children"> {
  icon?: React.ReactNode;
  label?: string | React.ReactNode;
  description?: string | React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  label,
  description,
  action,
  ...props
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
        textAlign: "center",
      }}
      {...props}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        bgcolor={theme.nawy.colors.semantic.layer.primary}
        borderRadius={theme.nawy.spacing.md}
        padding={theme.nawy.spacing.md}
        spacing={0}
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        {/* Icon */}
        {icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: label || description ? theme.nawy.spacing.sm : 0,
            }}
          >
            {icon}
          </Box>
        )}

        {/* Label and Description Container */}
        {(label || description) && (
          <Stack
            direction="column"
            alignItems="center"
            spacing={theme.nawy.spacing.xs}
            sx={{
              marginBottom: action ? theme.nawy.spacing.sm : 0,
            }}
          >
            {/* Label */}
            {label && (
              <Typography
                sx={{
                  ...theme.nawy.typography.english.variants.headline.xs,
                }}
              >
                {label}
              </Typography>
            )}

            {/* Description */}
            {description && (
              <Typography
                sx={{
                  ...theme.nawy.typography.english.variants.body.md.regular,
                }}
              >
                {description}
              </Typography>
            )}
          </Stack>
        )}

        {/* Action */}
        {action && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {action}
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default EmptyState;
